<template>
  <div class="success page">
    <div class="page-header">
      <div class="container">
        <h1 class="title">{{ $t('pagetitle.successful') }}</h1>
      </div>
    </div>
    <div class="page-body">
      <div class="container">
        <div class="message" v-if="id">
          <i class="el-icon-circle-check-outline"></i>
          <h1 class="title">{{ $t('subtitle.ordersuccessful') }}</h1>
          <span v-if="!($mq.resize && $mq.below('767px'))" class="text">{{ $t('subtitle.yourpurchaseorder') + id }}</span>
          <span v-if="($mq.resize && $mq.below('767px'))" class="text">{{ $t('subtitle.yourpurchaseorder') }}</span>
          <span v-if="($mq.resize && $mq.below('767px'))" class="text">{{ id }}</span>
          <span class="text">{{ $t('subtitle.ordersuccessfulemail') }}</span>
          <span class="text">{{ $t('subtitle.thankyou') }}</span>
          <el-button class="orange-button" @click="onSubmit($t('button.confirm'))">
            {{ $t('button.home') }}
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'successful',
  components: {
  },
  props: {
    id: {
      default: undefined
    }
  },
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
    this.onLoad()
  },
  methods: {
    onLoad () {
      if (!this.id) {
        this.$router.replace({ name: this.$t('route.cart') })
      }
    },
    onSubmit () {
      this.$router.replace({ name: this.$t('route.home') })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/styles/settings.scss";
.success {
  .page-body {
    background-color: $white-color;
    .container {
      padding-bottom: 50px;
    }
  }
  .message {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid #ccc;
    border-radius: 3px;
    padding: 50px 25px;
    i {
      font-size: 80px;
      color: $green-color;
    }
    .text {
      padding-bottom: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/cart/successful.vue